import { lazy } from 'react';
import {
    CREATE_PERMISSION,
    SOURCE_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from 'src/routing/components';

export const Routes = [
    {
        exact: true,
        path: '/create/source',
        guard: PermissionsGuard,
        roles: {
            permission: SOURCE_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/source/SourceCreateView')),
    },
    {
        exact: true,
        path: '/management/sources/:id',
        guard: PermissionsGuard,
        roles: {
            permission: SOURCE_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/source/SourceDetailsView')),
    },
    {
        exact: true,
        path: '/management/sources/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: SOURCE_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/source/SourceEditView')),
    },
    {
        exact: true,
        path: '/management/sources',
        guard: PermissionsGuard,
        roles: {
            permission: SOURCE_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/source/SourceListView')),
    },
];
